import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  Paper,
  TextField,
  Typography,
  Divider,
  InputAdornment,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Info } from "@material-ui/icons";

import { green } from "@material-ui/core/colors";
import React, { useState, useEffect } from "react";
import axios from "axios";

import {
  Edit,
  Visibility,
  Search as SearchIcon,
  ArrowDropDown,
  Refresh,
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";

import { PDFViewer } from "../../sasl/batch/updateBatch/StructuredInformation/PDFViewer";
import { appUrl } from "../../../../../../utils/config";

const initialValuesFromDb = {
  pci_sales_order_no: {
    value: "23540185",
    confidence: "95.01553344726562"
  },
  client_po: {
    value: "45152629",
    confidence: "95.13410186767578"
  },
  lot_no: {
    value: "C24050",
    confidence: "95.1100082397461"
  },
  pci_fg_no: {
    value: "723650",
    confidence: "95.46297454833984"
  },
  client_fg_no: {
    value: "1223158",
    confidence: "95.52490997314453"
  },
  ready_for_dispatch_quantity: {
    value: "3760",
    confidence: "95.2381820678711"
  },
  total_no_of_pallets: {
    value: "3",
    confidence: "67.52731323242188"
  },
  total_number_of_shippers: {
    value: "157",
    confidence: "67.52731323242188"
  },
  total_net_weight_of_pallets_kg: {
    value: "160",
    confidence: "67.52731323242188"
  },
  total_gross_weight_of_pallets_kg: {
    value: "205",
    confidence: "67.52731323242188"
  },
  full_pallet_dimensions: {
    value: "800*1200*1050",
    confidence: "94.0"
  },
  partial_pallet_dimensions: {
    value: "800*1200*750",
    confidence: "94.0"
  },
  ship_to_address: {
    value: "43233709 - Swords Laboratories Unlimited Company C/O UPS SCS (Nederland) B.V. Louis Pasteurweg 1 6045 GW Roermond NL",
    confidence: "92.67498016357422"
  },
  pick_up_location: {
    value: "City North Office: Block 7 City North Business Campus, Stamullen, Co Meath, Ireland",
    confidence: "94.70209503173828"
  },
  document_type: "PackingList",
  folder_name: "PCI",
  site_name: "Dublin",
  filename: "PCI-Dublin-PackingList-45152629-C24050.pdf",
  s3_location: "s3://bms-processed-files/PCI/Dublin/45152629-C24050/PCI-Dublin-PackingList-45152629-C24050.pdf"
};

// styling
const useStyles = makeStyles((theme) => ({
  formLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: "150px",
    paddingRight: theme.spacing(2),
    textAlign: "right",
  },
  fixedLabel: {
    width: 180,
    textAlign: "left",
    paddingRight: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
  sectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  testTable: {
    '& .MuiTableCell-head': {
      backgroundColor: '#f5f5f5',
      fontWeight: 'bold',
    },
  },
}));

const DigitizedPackingList = (props) => {
  const { initialData, onClose, schrockenCustomFileID, digitizedData } = props;
  const [isEditable, setIsEditable] = useState(false);
  const [formValues, setFormValues] = useState(initialData || {});
  const [originalValues, setOriginalValues] = useState(initialData || {});
  const [editedValues, setEditedValues] = useState(initialData || {});
  const [showingOriginal, setShowingOriginal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [modalData, setModalData] = useState({
    field: "",
    before: "",
    after: "",
    updatedBy: "user123",
    timestamp: new Date().toLocaleString(),
  });

  const classes = useStyles();

  useEffect(() => {
    const dataToUse = initialData || {};
    setFormValues(dataToUse);
    setOriginalValues(dataToUse);
    setEditedValues(dataToUse);
  }, [initialData]);

  // Validation functions based on data types
  const validateField = (fieldKey, value) => {
    const validations = {
      pci_sales_order_no: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "CMO Sales Order to Sponsor is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      client_po: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "Sponsor PO Number is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      lot_no: {
        type: "Alphanumeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "FG Batch is required";
          if (!/^[A-Za-z0-9]+$/.test(val)) return "Must be alphanumeric";
          return null;
        }
      },
      pci_fg_no: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "CMO FG Batch Number is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      client_fg_no: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "Sponsor Batch Number is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      ready_for_dispatch_quantity: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "Number of Units of Product Shipped is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      total_no_of_pallets: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "Number of Pallets is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      total_number_of_shippers: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "Number of Cartons is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      total_net_weight_of_pallets_kg: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "Net Weight is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      total_gross_weight_of_pallets_kg: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "Gross Weight is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      full_pallet_dimensions: {
        type: "Dimensions",
        validate: (val) => {
          if (!val || val.trim() === '') return "Full Pallet Dimensions is required";
          if (!/^\d+\*\d+\*\d+$/.test(val)) return "Must be in format: ###*###*###";
          return null;
        }
      },
      partial_pallet_dimensions: {
        type: "Dimensions",
        validate: (val) => {
          if (!val || val.trim() === '') return "Partial Pallet Dimensions is required";
          if (!/^\d+\*\d+\*\d+$/.test(val)) return "Must be in format: ###*###*###";
          return null;
        }
      },
      ship_to_address: {
        type: "Text",
        validate: (val) => {
          if (!val || val.trim() === '') return "Ship To address is required";
          if (val.length < 10) return "Address should be more detailed";
          return null;
        }
      },
      pick_up_location: {
        type: "Text",
        validate: (val) => {
          if (!val || val.trim() === '') return "Pickup Location is required";
          if (val.length < 10) return "Address should be more detailed";
          return null;
        }
      }
    };

    const fieldValidation = validations[fieldKey];
    if (fieldValidation) {
      return fieldValidation.validate(value);
    }
    return null;
  };

  const validateAllFields = () => {
    const errors = {};
    Object.keys(formValues).forEach(fieldKey => {
      const error = validateField(fieldKey, getValueForField(fieldKey));
      if (error) {
        errors[fieldKey] = error;
      }
    });
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getConfidenceForField = (fieldKey) => {
    const fieldData = formValues[fieldKey];
    if (fieldData && fieldData.confidence) {
      return parseFloat(fieldData.confidence);
    }
    return 90; // Default fallback
  };

  const getValueForField = (fieldKey, dataSource = formValues) => {
    const fieldData = dataSource[fieldKey];
    if (fieldData && typeof fieldData === 'object' && fieldData.value !== undefined) {
      return fieldData.value || '';
    }
    return fieldData || '';
  };

  const getLevelColor = (level) => {
    if (level < 80) return "red";
    if (level <= 90) return "orange";
    return "green";
  };

  const handleInputChange = (fieldKey, value) => {
    const newValues = {
      ...formValues,
      [fieldKey]: {
        ...formValues[fieldKey],
        value: value
      }
    };
    setFormValues(newValues);
    if (!showingOriginal) {
      setEditedValues(newValues);
    }

    // Validate the field and update errors
    const error = validateField(fieldKey, value);
    setValidationErrors(prev => ({
      ...prev,
      [fieldKey]: error
    }));
  };

  const handleSave = async () => {
    if (validateAllFields()) {
      try {
        setSaving(true);
        
        // Parse existing kvpJson and update with current form values
        const existingKvpJson = digitizedData?.kvpJson ? JSON.parse(digitizedData.kvpJson) : {};
        
        // Update kvpJson with current form values
        const updatedKvpJson = {
          ...existingKvpJson,
          pci_sales_order_no: {
            value: getValueForField('pci_sales_order_no'),
            confidence: existingKvpJson.pci_sales_order_no?.confidence || 90
          },
          client_po: {
            value: getValueForField('client_po'),
            confidence: existingKvpJson.client_po?.confidence || 90
          },
          lot_no: {
            value: getValueForField('lot_no'),
            confidence: existingKvpJson.lot_no?.confidence || 90
          },
          pci_fg_no: {
            value: getValueForField('pci_fg_no'),
            confidence: existingKvpJson.pci_fg_no?.confidence || 90
          },
          client_fg_no: {
            value: getValueForField('client_fg_no'),
            confidence: existingKvpJson.client_fg_no?.confidence || 90
          },
          ready_for_dispatch_quantity: {
            value: getValueForField('ready_for_dispatch_quantity'),
            confidence: existingKvpJson.ready_for_dispatch_quantity?.confidence || 90
          },
          total_no_of_pallets: {
            value: getValueForField('total_no_of_pallets'),
            confidence: existingKvpJson.total_no_of_pallets?.confidence || 90
          },
          total_number_of_shippers: {
            value: getValueForField('total_number_of_shippers'),
            confidence: existingKvpJson.total_number_of_shippers?.confidence || 90
          },
          total_net_weight_of_pallets_kg: {
            value: getValueForField('total_net_weight_of_pallets_kg'),
            confidence: existingKvpJson.total_net_weight_of_pallets_kg?.confidence || 90
          },
          total_gross_weight_of_pallets_kg: {
            value: getValueForField('total_gross_weight_of_pallets_kg'),
            confidence: existingKvpJson.total_gross_weight_of_pallets_kg?.confidence || 90
          },
          full_pallet_dimensions: {
            value: getValueForField('full_pallet_dimensions'),
            confidence: existingKvpJson.full_pallet_dimensions?.confidence || 90
          },
          partial_pallet_dimensions: {
            value: getValueForField('partial_pallet_dimensions'),
            confidence: existingKvpJson.partial_pallet_dimensions?.confidence || 90
          },
          ship_to_address: {
            value: getValueForField('ship_to_address'),
            confidence: existingKvpJson.ship_to_address?.confidence || 90
          },
          pick_up_location: {
            value: getValueForField('pick_up_location'),
            confidence: existingKvpJson.pick_up_location?.confidence || 90
          }
        };

        // Prepare API request payload
        const requestPayload = {
          vendorMosymphonyID: digitizedData?.vendorMosymphonyID || 3,
          digitizedExtractedDataList: [{
            poNumber: digitizedData?.poNumber,
            batchNumber: digitizedData?.batchNumber,
            processedFileName: digitizedData?.processedFileName,
            senderEmailID: digitizedData?.senderEmailID,
            emailReceivedTimestamp: digitizedData?.emailReceivedTimestamp,
            attachmentName: digitizedData?.attachmentName,
            documentType: digitizedData?.documentType,
            documentFormat: digitizedData?.documentFormat,
            emailSubject: digitizedData?.emailSubject || "",
            emailBody: digitizedData?.emailBody || "",
            schrockenCustomFileID: digitizedData?.schrockenCustomFileID,
            kvpJson: JSON.stringify(updatedKvpJson),
            siteName: digitizedData?.siteName
          }]
        };

        // Make API call
        const response = await axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDigitizedExtractedData`,
          requestPayload
        );

        if (response.data.status) {
          // Save changes locally
          setEditedValues(formValues);
          setIsEditable(false);
          setShowingOriginal(false);
          
          //console.log('Packing List data saved successfully');
        } else {
          console.error('Failed to save:', response.data.message);
        }
      } catch (error) {
        console.error('Error saving Packing List data:', error);
      } finally {
        setSaving(false);
      }
    }
  };

  const getFieldErrorProps = (fieldKey) => ({
    error: !!validationErrors[fieldKey],
    helperText: validationErrors[fieldKey]
  });

  const renderField = (fieldKey, label, placeholder, multiline = false, rows = 1) => (
    <Grid
      container
      alignItems="center"
      spacing={2}
      className={classes.formField}
    >
      <Grid item xs={4}>
        <Box display="flex" alignItems="center">
          <Typography
            style={{
              paddingRight: 16,
              fontWeight: 500,
            }}
          >
            {label}
            <span className={classes.requiredStar}>*</span>
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={8}>
        <TextField
          variant="outlined"
          fullWidth
          size="small"
          value={getValueForField(fieldKey)}
          onChange={(e) =>
            handleInputChange(fieldKey, e.target.value)
          }
          onBlur={(e) => {
            const { value } = e.target;
            // Trim leading and trailing spaces for string values
            if (typeof value === "string" && value.trim() !== value) {
              handleInputChange(fieldKey, value.trim());
            }
          }}
          placeholder={placeholder}
          multiline={multiline}
          rows={rows}
          {...getFieldErrorProps(fieldKey)}
          InputProps={{
            readOnly: !isEditable,
            endAdornment: (
              <InputAdornment position="end">
                <Box display="flex" alignItems="center" pl={1}>
                  <Box
                    style={{
                      width: 1,
                      height: multiline ? 50 : 39,
                      backgroundColor: "#ccc",
                      marginRight: 3,
                    }}
                  />
                  {!isEditable ? (
                    getValueForField(fieldKey) !== getValueForField(fieldKey, originalValues) ? (
                      <Box
                        onClick={() => {
                          setModalData({
                            field: label,
                            before: getValueForField(fieldKey, originalValues),
                            after: getValueForField(fieldKey),
                            updatedBy: "user123",
                            timestamp:
                              new Date().toLocaleString(),
                          });
                          setOpenModal(true);
                        }}
                        style={{
                          backgroundColor: "#7777",
                          color: "white",
                          borderRadius: 4,
                          padding: "2px 8px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          minWidth: 24,
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                      >
                        <Info fontSize="small" />
                      </Box>
                    ) : (
                      <Box
                        style={{
                          backgroundColor: getLevelColor(getConfidenceForField(fieldKey)),
                          color: "white",
                          borderRadius: 4,
                          padding: "2px 8px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          minWidth: 24,
                          textAlign: "center",
                        }}
                      >
                        {Math.round(getConfidenceForField(fieldKey))}
                      </Box>
                    )
                  ) : (
                    <Box
                      style={{
                        backgroundColor: getLevelColor(getConfidenceForField(fieldKey)),
                        color: "white",
                        borderRadius: 4,
                        padding: "2px 8px",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        minWidth: 24,
                        textAlign: "center",
                      }}
                    >
                      {Math.round(getConfidenceForField(fieldKey))}
                    </Box>
                  )}
                </Box>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>
  );

  return (
    <>
      <Grid container direction="column" spacing={2}>

        {/* Actions*/}
        <Grid item container alignItems="center" spacing={2}>
          <Grid item xs={6}>
            <Grid item style={{display: "flex", alignItems: "center"}} spacing={2}>
              <Typography
                variant="h6"
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  marginRight: "8px",
                }}
              >
                Packing List Data
              </Typography>
              <Box display="flex" gap={1} spacing={2}>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    if (isEditable) {
                      handleSave();
                    } else {
                      // Start editing
                      setIsEditable(true);
                      setShowingOriginal(false);
                      setFormValues(editedValues);
                    }
                  }}
                  style={{ marginRight: "8px", minWidth: 15, textAlign: "center" }}
                  disabled={saving}
                >
                  {saving ? "Saving..." : isEditable ? "Save Changes" : "Edit"}
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={() => {
                    if (showingOriginal) {
                      // Show edited version
                      setFormValues(editedValues);
                      setShowingOriginal(false);
                    } else {
                      // Show original version
                      setFormValues(originalValues);
                      setShowingOriginal(true);
                    }
                    setIsEditable(false);
                  }}
                  style={{ marginRight: "8px", minWidth: 20, textAlign: "center", size: "20px" }}
                >
                  {showingOriginal ? "Show Edited Version" : "Show Unedited Version"}
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h6">PDF Preview</Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {/* CMO Sales Order to Sponsor */}
              {renderField('pci_sales_order_no', 'CMO Sales Order to Sponsor', 'Enter CMO Sales Order to Sponsor')}

              {/* Sponsor PO Number */}
              {renderField('client_po', 'Sponsor PO Number', 'Enter Sponsor PO Number')}

              {/* FG Batch */}
              {renderField('lot_no', 'FG Batch', 'Enter FG Batch')}

              {/* CMO FG Batch Number */}
              {renderField('pci_fg_no', 'CMO FG Batch Number', 'Enter CMO FG Batch Number')}

              {/* Sponsor Batch Number */}
              {renderField('client_fg_no', 'Sponsor Batch Number', 'Enter Sponsor Batch Number')}

              {/* Number of Units of Product Shipped */}
              {renderField('ready_for_dispatch_quantity', 'Number of Units of Product Shipped', 'Enter Number of Units of Product Shipped')}

              {/* Number of Pallets */}
              {renderField('total_no_of_pallets', 'Number of Pallets', 'Enter Number of Pallets')}

              {/* Number of Cartons */}
              {renderField('total_number_of_shippers', 'Number of Cartons', 'Enter Number of Cartons')}

              {/* Net Weight */}
              {renderField('total_net_weight_of_pallets_kg', 'Net Weight', 'Enter Net Weight')}

              {/* Gross Weight */}
              {renderField('total_gross_weight_of_pallets_kg', 'Gross Weight', 'Enter Gross Weight')}

              {/* Full Pallet Dimensions */}
              {renderField('full_pallet_dimensions', 'Full Pallet Dimensions', 'Enter Full Pallet Dimensions (###*###*###)')}

              {/* Partial Pallet Dimensions */}
              {renderField('partial_pallet_dimensions', 'Partial Pallet Dimensions', 'Enter Partial Pallet Dimensions (###*###*###)')}

              {/* Ship To */}
              {renderField('ship_to_address', 'Ship To', 'Enter Ship To Address', true, 3)}

              {/* Pickup Location */}
              {renderField('pick_up_location', 'Pickup Location', 'Enter Pickup Location', true, 2)}

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "28px" }} />
                {/* Green Box */}
                <Box
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                  }}
                >
                  &gt; 90
                </Box>
                {/* Orange Box */}
                <Box
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 50,
                    marginLeft: 16,
                  }}
                >
                  80 to 90
                </Box>
                {/* Red Box */}
                <Box
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                    marginLeft: 16,
                  }}
                >
                  &lt; 80
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Right side: PDF view */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  border: "1px dashed #ccc",
                }}
              >
                {schrockenCustomFileID ? (
                  <PDFViewer schrockenCustomFileID={schrockenCustomFileID} />
                ) : (
                  <Box
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography>No PDF available</Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Table>
            <TableHead
              style={{ border: "1px solid grey", backgroundColor: "#7777" }}
            >
              <TableRow
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableCell>
                  <b>Timestamp</b>
                </TableCell>
                <TableCell>
                  <b>Before Value</b>
                </TableCell>
                <TableCell>
                  <b>After Value</b>
                </TableCell>
                <TableCell>
                  <b>Updated By</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ border: "1px solid grey" }}>
              <TableRow>
                <TableCell>{modalData.timestamp}</TableCell>
                <TableCell>{modalData.before}</TableCell>
                <TableCell>{modalData.after}</TableCell>
                <TableCell>{modalData.updatedBy}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DigitizedPackingList;
